export default __webpack_public_path__ + "static/media/pompePress.2e712f74.png";